import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'

const TagVisibilityBadge = ({ isPublic }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '2px 8px',
      borderRadius: '999px',
      border: `1px solid ${isPublic ? '#a7ddc2' : '#e0e4ea'}`,
      backgroundColor: isPublic ? '#eaf7f0' : 'transparent',
      color: isPublic ? '#1f8a5c' : '#6b7280',
      lineHeight: 1,
    }}
  >
    <Icon
      icon={isPublic ? 'mdi:web' : 'mdi:lock-outline'}
      width={12}
      height={12}
    />
    <Typography
      component="span"
      sx={{ fontSize: '11px', fontWeight: 600, lineHeight: 1, color: 'inherit' }}
    >
      {isPublic ? 'Public' : 'Private'}
    </Typography>
  </Box>
)

export default TagVisibilityBadge
